(function () {
	const submitFormKey = "submit-form-key";
	const submitFormTimeKey = "submit-form-time-key";

	function initSubscribeFormAction () {
		const formsData = [
			{
				node: document.querySelector("#footer-form")
			},
			{
				node: document.querySelector("#newsletter-section-form")
			},
			{
				node: document.querySelector("#popup-form")
			}
		];

		setTimeout(() => {
			formsData.forEach(el => {
				if (el.node) {
					const formButton = el.node.querySelector(".newsletter__button");
					if (formButton) {
						formButton.addEventListener("click", function(){
							localStorage.setItem(submitFormKey, el.node.id);
							localStorage.setItem(submitFormTimeKey, Date.now());
							el.node.submit();
						});
					}
				}
			});
		}, 1000);
	}

	function clearOldFormData () {
		const storedTime = localStorage.getItem(submitFormTimeKey);

		if (storedTime) {
			const now = Date.now();
			const validTime = 60 * 1000;

			if (now - storedTime > validTime) {
				localStorage.removeItem(submitFormKey);
				localStorage.removeItem(submitFormTimeKey);
			}
		}
	}

	function checkSuccessMessage () {
		setTimeout(() => {
			const getSubmitFormId = localStorage.getItem(submitFormKey);
			if (getSubmitFormId) {
				const getSubmitFormElem = document.querySelector(`#${getSubmitFormId}`);
				getSubmitFormElem.querySelector(".newsletter-form__message--success")?.classList.remove('hidden');
			}
		}, 500);
	}

	initSubscribeFormAction();
	checkSuccessMessage();
	clearOldFormData();

	document.addEventListener("shopify:section:load", function () {
		initSubscribeFormAction();
		checkSuccessMessage();
		clearOldFormData();
	});
})();
